<div class="wrapper">
  <div class="heading">
    {{ heading }}
  </div>
  <section class="content section">
    @if (data.pictures?.length) {
      <app-attachments-block
        class="attachments-section"
        [pictures]="data.pictures"
        />
    }
  </section>
</div>
